import React, { useEffect, useRef, useState } from "react";
import { PhoneFrame } from "@/components/landing/PhoneMockup";
import { TrainScreen, HistoryScreen, ProgressScreen } from "@/components/landing/PreviewScreens";
import { SectionShell, SectionHead } from "@/components/landing/LandingUI";

const REPEATS = 3;

export function AppPreview({ lang }) {
  const id = lang === "id";
  const [paused, setPaused] = useState(false);
  const timer = useRef(null);
  useEffect(() => () => { clearTimeout(timer.current); }, []);

  const hold = () => { clearTimeout(timer.current); setPaused(true); };
  const release = () => { clearTimeout(timer.current); timer.current = setTimeout(() => setPaused(false), 2500); };

  const screens = [
    { key: "train", Screen: TrainScreen, title: id ? "Latihan" : "Train", desc: id ? "Sesi live dengan timer & deteksi PR" : "Live sessions with timer & PR detection" },
    { key: "history", Screen: HistoryScreen, title: id ? "Riwayat" : "History", desc: id ? "Kalender check-in, latihan & kalori" : "Check-in, workout & calorie calendar" },
    { key: "progress", Screen: ProgressScreen, title: id ? "Progres" : "Progress", desc: id ? "Heatmap konsistensi, 1RM & PR" : "Consistency heatmap, 1RM & PRs" },
  ];
  const items = Array.from({ length: REPEATS * 2 }, () => screens).flat();

  return (
    <SectionShell id="preview" inner="max-w-none">
      <div className="px-5">
        <SectionHead testid="preview-heading" label={id ? "Preview Aplikasi" : "App Preview"}
          title={id ? "Lihat aplikasinya" : "See the app"} accent={id ? "beraksi" : "in action"}
          sub={id ? "Tampilan yang bersih dan nyaman, supaya kamu fokus ke latihan." : "A clean, comfortable interface so you can focus on training."} />
      </div>
      <div className="marquee mt-14 overflow-hidden sm:mt-16" data-testid="app-preview-marquee"
        onPointerDown={hold} onPointerUp={release} onPointerCancel={release} onPointerLeave={release}
        style={{ maskImage: "linear-gradient(90deg, transparent, black 8%, black 92%, transparent)", WebkitMaskImage: "linear-gradient(90deg, transparent, black 8%, black 92%, transparent)" }}>
        <div className={`marquee-track flex gap-5 px-2.5 sm:gap-6 ${paused ? "is-paused" : ""}`} data-testid="app-preview-track" data-paused={paused}>
          {items.map(({ key, Screen, title, desc }, i) => (
            <div key={`${key}-${i}`} className="flex-shrink-0" aria-hidden={i >= screens.length} data-testid={i < screens.length ? `preview-phone-${key}` : undefined}>
              <PhoneFrame className="h-[520px] w-[250px] transition-transform duration-300 hover:scale-[1.02] sm:h-[560px] sm:w-[280px]">
                <Screen id={id} />
              </PhoneFrame>
              <div className="mt-4 text-center">
                <div className="font-display text-base font-bold text-white">{title}</div>
                <div className="text-xs text-slate-400">{desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </SectionShell>
  );
}
